<div class="w-full bg-white aarni-font mt-[80px]">
    <div class="container flex flex-col sm:flex-row justify-center sm:justify-between py-12 m-auto px-4">
        <h1 class="font-bold text-[32px] text-center sm:text-start">
            {{ pageTitle }}
        </h1>
    </div>
</div>

<div class="flex items-start justify-center p-4 bg-gray-50 aarni-font">
    <div class="flex flex-col lg:flex-row gap-4 p-4 w-full container m-auto">
        <aside class="w-full lg:w-1/4 space-y-4 lg:max-h-screen lg:overflow-y-auto overflow-x-hidden pr-2">
            <div class="border-t-8 border-blue-400">
                <div class="bg-white shadow border border-gray-300">
                    <h2 class="text-lg font-bold p-4">Academic Info</h2>
                    <div class="">
                        <a [href]="'/academic-info/exam-result'"
                             [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Exam Result', 'text-blue-600 bg-white' : pageTitle !== 'Exam Result'}"
                             class="flex items-center space-x-2 p-3 w-full border-y border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Exam Results</span>
                        </a>
                        <a [href]="'/academic-info/examination-schedule'"
                             [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Examination Schedule', 'text-blue-600 bg-white' : pageTitle !== 'Examination Schedule'}"
                             class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Examination Schedule</span>
                        </a>
                        <a [href]="'/academic-info/examination-annual-report'"
                             [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Examination Annual Report', 'text-blue-600 bg-white' : pageTitle !== 'Examination Annual Report'}"
                             class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Examination Annual Report</span>
                        </a>
                        <a [href]="'/academic-info/academic-calender'"
                             [ngClass]="{'text-white bg-blue-600' : pageTitle === 'Academic Calender', 'text-blue-600 bg-white' : pageTitle !== 'Academic Calender'}"
                             class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Academic Calender</span>
                        </a>
                        <a [href]="'/academic-info/system-of-grading'"
                             [ngClass]="{'text-white bg-blue-600' : pageTitle === 'System of Grading', 'text-blue-600 bg-white' : pageTitle !== 'System of Grading'}"
                             class="flex items-center space-x-2 p-3 w-full  border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>System of Grading</span>
                        </a>
                        <!--<div (click)="goTo('/academic-info/programme-curricula')"
                             [ngClass]="{'text-white bg-blue-600' : pageTitle === 'programme curriculum', 'text-blue-600 bg-white' : pageTitle !== 'Programme Curricula'}"
                             class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Program Curriculum</span>
                        </div>-->
                        <div (click)="goTo('/academic-info/university-prospectus')"
                             [ngClass]="{'text-white bg-blue-600' : pageTitle === 'University Prospectus', 'text-blue-600 bg-white' : pageTitle !== 'University Prospectus'}"
                             class="flex items-center space-x-2 p-3 w-full hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>University Prospectus</span>
                        </div>
                    </div>
                </div>
            </div>
            <h2 class="text-lg font-semibold mb-4 hidden lg:block">Quick Links</h2>
            <div class="bg-white p-4 rounded-lg shadow hidden lg:block border-gray-200 border-2">
                <div class="space-y-2">
                    <a href="/quick-links/student-testimonial" class="flex items-center space-x-3 p-2 rounded-lg">
                        <div>
                        <span class="w-16 h-16 flex items-center justify-center bg-green-600 text-white rounded-full">
                            <i class="fa fa-comment text-2xl"></i>
                        </span>
                        </div>
                        <span class="text-gray-700 font-medium text-[16px] xl:text-xl">Testimonials</span>
                    </a>
                </div>
            </div>

            <div class="bg-white p-4 rounded-lg shadow hidden lg:block border-gray-200 border-2">
                <div class="space-y-2">
                    <a href="/whats-happening/event-calendar" class="flex items-center space-x-3 p-2 rounded-lg">
                        <div>
                        <span class="w-16 h-16 flex items-center justify-center bg-yellow-500 text-white rounded-full">
                          <i class="fa fa-calendar text-2xl"></i>
                        </span>
                        </div>
                        <span class="text-gray-700 font-medium text-[16px] xl:text-xl">What's Happening</span>
                    </a>
                </div>
            </div>
            <div class="bg-white p-4 rounded-lg shadow hidden lg:block border-gray-200 border-2">
                <div class="space-y-2">
                    <a href="/quick-links/contact-us" class="flex items-center space-x-3 p-2 rounded-lg ">
                        <div>
            <span class="w-16 h-16 flex items-center justify-center bg-pink-600 text-white rounded-full">
                <i class="fa fa-phone text-2xl"></i>
            </span></div>
                        <span class="text-gray-700 font-medium text-[16px] xl:text-xl">Contact Us</span>
                    </a>
                </div>
            </div>

           <!-- <div class="bg-white p-4 rounded-lg shadow hidden lg:block border-gray-200 border-2">
                <div class="space-y-2">
                    <a href="/quick-links/image-gallery" class="flex items-center space-x-3 p-2 rounded-lg ">
                        <div>
            <span class="w-16 h-16 flex items-center justify-center bg-blue-600 text-white rounded-full">
                <i class="fa fa-camera text-2xl"></i>
            </span></div>
                        <span class="text-gray-700 font-medium text-[16px] xl:text-xl">Image Gallery</span>
                    </a>
                </div>
            </div>-->
        </aside>
        <section class="flex-1 p-4 shadow-lg border-gray-200 bg-white">
            <h1 class="text-[24px] font-semibold my-6"
                *ngIf="pageTitle !== 'Academic Calender'">{{ pageTitle }}</h1>
            <h1 class="text-[24px] font-semibold my-6" *ngIf="pageTitle === 'Academic Calender'">Academic Calender
                & Holiday List</h1>
            <div class="mx-auto border-gray-200 border p-4 my-8"
                 *ngIf="pageTitle === 'Exam Result' || pageTitle === 'Examination Schedule'">
                <div class="space-y-4" *ngIf="pageTitle === 'Exam Result'">

                    <!-- Accordion List -->
                    <div *ngFor="let section of examResultSections; let i = index">
                        <button
                            class="w-full flex items-center p-2"
                            (click)="toggleAccordion(i)"
                        >
                            <i
                                class="text-lg"
                                [ngClass]="activeIndex === i ? 'fas fa-minus text-blue-500' : 'fas fa-plus text-blue-500'"
                            ></i>
                            <span class="ml-2 text-start font-bold text-lg md:text-xl">
        {{ section.heading }}
      </span>
                        </button>
                        <div
                            *ngIf="activeIndex === i"
                            @fadeInOut
                            class="p-2 text-gray-700 sm:text-sm"
                            [innerHTML]="section.content"
                        ></div>
                        <hr *ngIf="i < examResultSections.length - 1"/>
                    </div>
                </div>
                <div *ngIf="examResultSections && examResultSections.length > 0; else noData">
                    <div *ngFor="let section of examResultSections; let i = index">
                        <button class="w-full flex items-center p-2" (click)="toggleAccordion(i)">
                            <i class="text-lg"
                               [ngClass]="activeIndex === i ? 'fas fa-minus text-blue-500' : 'fas fa-plus text-blue-500'"
                            ></i>
                            <span class="ml-2 text-start font-bold text-lg md:text-xl">
                                 {{ section.heading }}
                            </span>
                        </button>
                        <div
                            *ngIf="activeIndex === i"
                            @fadeInOut
                            class="p-2 text-gray-700 sm:text-sm"
                            [innerHTML]="section.content"
                        ></div>

                        <hr *ngIf="i < examResultSections.length - 1"/>
                    </div>
                </div>

            </div>
            <div class="space-y-4" *ngIf="pageTitle === 'University Prospectus'">
                <iframe
                    src="assets/pdf/arni-university-prospectus.pdf"
                    width="100%"
                    height="600px"
                    style="border: none;"
                ></iframe>
            </div>
            <div *ngIf="pageTitle === 'Examination Annual Report' || pageTitle === 'System of Grading'" class="px-6 border p-4">
                <ng-container
                    *ngIf="(pageTitle === 'Examination Annual Report' && hasAnnualReport) || (pageTitle === 'System of Grading' && hasSystemGrading); else noData">
                    <a
                        href="your-annual-report-url.pdf"
                        target="_blank"
                        class="underline text-red-600 text-[12px]"
                        *ngIf="pageTitle === 'Examination Annual Report'"
                    >
                        <i class="fa-solid fa-file-pdf mr-2"></i>
                        Annual examination report
                    </a>

                    <a
                        href="your-grading-system-url.pdf"
                        target="_blank"
                        class="underline text-blue-600 text-[12px]"
                        *ngIf="pageTitle === 'System of Grading'"
                    >
                        Click here to download system of grading
                    </a>
                </ng-container>
            </div>

            <div *ngIf="pageTitle === 'Academic Calender'" class="px-6  p-4 border">
                <ng-container *ngIf="academicCalendarList && academicCalendarList.length > 0; else noData">
                    <div *ngFor="let cal of academicCalendarList">
                        <div class="font-semibold text-[14px]">{{ cal.year }}</div>
                        <ul class="pl-6 my-3">
                            <li class="list-disc">
                                <a [href]="cal.link" target="_blank" class="text-[12px] underline text-blue-500">
                                    {{ cal.title }}
                                </a>
                            </li>
                        </ul>
                    </div>
                </ng-container>
            </div>
            <!--  <div *ngIf="pageTitle === 'Programme Curriculum'" class="my-8 mx-6">
                  <ng-container *ngIf="curriculumList && curriculumList.length > 0; else noData">
                      <div class="flex gap-4 mb-6">
                          <button class="bg-[#D4AF37] text-white px-3 py-2 rounded">
                              Program Curriculum 2025-26
                          </button>
                      </div>
                      <div class="mt-8 overflow-x-auto">
                          <table class="border border-primary-dark min-w-full">
                              <thead>
                              <tr class="bg-blue-600 text-white">
                                  <th class="text-nowrap px-2 py-3">S. No.</th>
                                  <th class="text-nowrap px-2 py-3">Program Code</th>
                                  <th class="text-nowrap px-2 py-3">Program Name</th>
                                  <th class="text-nowrap px-2 py-3">Curriculum</th>
                              </tr>
                              </thead>
                              <tbody>
                              <tr *ngFor="let curriculum of curriculumList; let i = index" class="border-b">
                                  <td class="border-r text-center">{{ i + 1 }}</td>
                                  <td class="border-r text-center">{{ curriculum.code }}</td>
                                  <td class="border-r text-[14px] px-3">{{ curriculum.name }}</td>
                                  <td class="px-3">
                                      <a [href]="curriculum.link" target="_blank" class="text-[12px] text-blue-500">
                                          {{ curriculum.link }}
                                      </a>
                                  </td>
                              </tr>
                              </tbody>
                          </table>
                      </div>
                  </ng-container>
              </div>-->
        </section>
    </div>
    <!-- No Data Template -->
    <ng-template #noData>
        <div class="text-center text-gray-500 text-lg py-6">
            No data available to display.
        </div>
    </ng-template>
</div>
